import { lazy } from 'react';
import type { RouteProps } from 'react-router-dom';

const ModifyPassword = lazy(() => import('./index'));

/** 路由配置 */
export const routeConfig: RouteProps[] = [
  {
    path: '/modifyPassword',
    element: <ModifyPassword />,
  },
];
